// extracted by mini-css-extract-plugin
module.exports =  {"title":"QRdsOr","text":"cHB9u5","section":"yV19A7","column":"PJnSe4"};